module.exports = __webpack_public_path__ + "media/images/app/how-it-works/rbtd-icon-8223e87153bccb22ef25565e6f9a8e95.webp";